/**
 * Variant fast paint - PE (Sasha 2026-10-06: the add-to-cart button greys "like it's loading for half a second" on
 * every size change). Data: snippets/paex-variant-fast.liquid (#PaexVariantFast-<section>).
 *
 * Native today (assets/global.js HighVariantSelects, UNCHANGED): the picker's own `change` listener disables the
 * button (toggleAddButtonStatus(true, "")) and fetches the whole main-product section; the button comes back only
 * when that answer is applied (~0.45 s desktop, ~0.7 s phone).
 *
 * This file wraps HighVariantSelects.prototype.renderProductInfo at runtime (global.js itself is not edited): the native
 * method runs first and unchanged, then paint() runs in the same task, so it lands before the browser draws a frame:
 * the grey is never painted, and the button label/state, price block, selected-value label, sticky-bar price/title and
 * the forms' variant id are already right.
 * It dispatches no events and does not touch the URL: the native refresh still runs in the background exactly as
 * before (one replaceState, one id-input change, one variantChange publish for every paex subscriber) and overwrites
 * all of this with the server's answer. Last tap wins: each tap paints synchronously, the native AbortController
 * cancels the earlier request. Anything missing (no table, quick-view clone, combination not in the table) = no
 * paint = today's behaviour.
 */
(function () {
  if (window.paexVariantFast) return;
  var tables = {};

  function table(S) {
    var el = document.getElementById('PaexVariantFast-' + S);
    if (!el) return null;
    if (!tables[S] || tables[S].el !== el) {
      try {
        tables[S] = { el: el, t: JSON.parse(el.textContent) };
      } catch (e) {
        return null;
      }
    }
    return tables[S].t;
  }

  // The price block's skip marker must always describe what #Price-<S> shows: drop it whenever the paint steps aside
  // (the server then writes a price we did not key), and re-key it from every server answer (review fix 2026-10-06).
  function unmark(S) {
    var price = S && document.getElementById('Price-' + S);
    if (price) delete price.dataset.paexPvf;
  }

  function paint(host) {
    var ok = false;
    try {
      ok = paintRow(host);
    } catch (e) {
      ok = false;
    }
    if (!ok && host && host.dataset && !host.dataset.originalSection) unmark(host.dataset.section);
    return ok;
  }

  function paintRow(host) {
    if (!host || host.dataset.originalSection || typeof host.toggleAddButtonStatus !== 'function') return false;
    var S = host.dataset.section, t = table(S);
    if (!t || !t.v) return false;

    var groups = host.querySelectorAll('.product-form-input'), picked = [], i;
    for (i = 0; i < groups.length; i++) {
      var f = groups[i].querySelector('.form-options-wrapper input:checked, .form-options-wrapper select');
      if (!f || !f.value) return false;
      picked.push(f.value);
    }
    var row = null;
    for (i = 0; i < t.v.length && !row; i++) {
      if (t.v[i][1].length === picked.length && t.v[i][1].every(function (o, k) { return o === picked[k]; })) row = t.v[i];
    }
    if (!row) return false;

    var st = row[2];
    var price = document.getElementById('Price-' + S);
    var priced = !!(price && row[3] && t.p[row[3]] != null);
    // The pre-order line property (properties[Sale type]) lives inside #Price-<S> and is only swapped with the price. When
    // the price is not painted from the table (unit pricing, same price / different compare-at), an add inside the
    // refresh window would post the previous size's property: step aside (today's grey) unless it already matches.
    if (price && !priced && (st === 'p') !== !!price.querySelector('input[name^="properties["]')) return false;

    host.toggleAddButtonStatus(st === 's', t.s[st]);
    // Notify me: only ever hidden here. Its form (#Notify-Email-<S>) still names the previous size until the server
    // answer swaps it, so revealing the button is left to that answer (review fix 2026-10-06).
    var notify = document.getElementById('Notify-Email-Button-' + S);
    if (notify && st !== 's') notify.classList.add('hidden');
    // Finish the look - PE: re-apply the add-on CTA label the reset above just overwrote (no label flicker).
    var addon = document.querySelector('paex-addon[data-section="' + S + '"]');
    if (addon && typeof addon.resyncCta === 'function') addon.resyncCta();

    document
      .querySelectorAll('#product-form-' + S + ' input[name="id"], #product-form-installment-' + S + ' input[name="id"]')
      .forEach(function (input) { input.value = row[0]; });

    if (priced) {
      if (price.dataset.paexPvf !== row[3]) {
        price.innerHTML = t.p[row[3]];
        price.dataset.paexPvf = row[3];
      }
      price.classList.remove('hidden'); // setUnavailable() hid it after an unavailable combination
    }

    for (i = 0; i < groups.length; i++) {
      var label = groups[i].querySelector('.form-label > span');
      if (label) label.textContent = picked[i];
    }

    var mini = document.getElementById('Product-Mini-Checkout-' + S);
    if (mini) {
      var mp = mini.querySelector('.product-content .price'), mt = mini.querySelector('.product-content small');
      if (mp) mp.innerHTML = row[4];
      if (mt) mt.innerHTML = row[5];
    }
    return true;
  }

  window.paexVariantFast = { paint: paint };

  // Re-key the price marker from the variant the server just rendered (it ran updateBlock('Price') before publishing).
  if (typeof webvista !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined' && webvista && typeof webvista.subscribe === 'function') {
    webvista.subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      try {
        var d = event && event.data, S = d && d.sectionId, t = S && table(S), price = S && document.getElementById('Price-' + S);
        if (!price) return;
        var key = '';
        if (t && t.v && d.variant) {
          for (var i = 0; i < t.v.length; i++) if (t.v[i][0] === d.variant.id) { key = t.v[i][3]; break; }
        }
        if (key) price.dataset.paexPvf = key;
        else delete price.dataset.paexPvf;
      } catch (e) {
        /* no-op */
      }
    });
  }

  // Run right after the native renderProductInfo has started its request: that covers a pill tap (onVariantChange) and
  // the size guide's applySize, both of which disable the button first. Same task, so no frame shows the grey.
  function wrap(C) {
    var native = C && C.prototype.renderProductInfo;
    if (typeof native !== 'function' || native.paexVariantFast) return;
    C.prototype.renderProductInfo = function () {
      var out = native.apply(this, arguments);
      paint(this);
      return out;
    };
    C.prototype.renderProductInfo.paexVariantFast = true;
  }
  if (window.customElements) {
    if (customElements.get('high-variant-selects')) wrap(customElements.get('high-variant-selects'));
    else customElements.whenDefined('high-variant-selects').then(function () { wrap(customElements.get('high-variant-selects')); });
  }
})();
